// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/types/asset_pair.proto" (package "mlmbox.types", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Asset_Id } from "./asset.ts";
/**
 * @generated from protobuf message mlmbox.types.AssetPair
 */
export interface AssetPair {
    /**
     * @generated from protobuf field: uint32 asset_pair_id = 1;
     */
    assetPairId: number;
    /**
     * @generated from protobuf field: string asset_pair_name = 2;
     */
    assetPairName: string;
    /**
     * @generated from protobuf field: uint32 source_asset_id = 3;
     */
    sourceAssetId: number;
    /**
     * @generated from protobuf field: uint32 target_asset_id = 4;
     */
    targetAssetId: number;
}
/**
 * @generated from protobuf message mlmbox.types.AssetPair.Id
 */
export interface AssetPair_Id {
    /**
     * @generated from protobuf oneof: query
     */
    query: {
        oneofKind: "assetPairId";
        /**
         * @generated from protobuf field: uint32 asset_pair_id = 1;
         */
        assetPairId: number;
    } | {
        oneofKind: "assetPairName";
        /**
         * @generated from protobuf field: string asset_pair_name = 2;
         */
        assetPairName: string;
    } | {
        oneofKind: "assets";
        /**
         * @generated from protobuf field: mlmbox.types.AssetPair.Id.Assets assets = 3;
         */
        assets: AssetPair_Id_Assets;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message mlmbox.types.AssetPair.Id.Assets
 */
export interface AssetPair_Id_Assets {
    /**
     * @generated from protobuf field: mlmbox.types.Asset.Id source_asset = 1;
     */
    sourceAsset?: Asset_Id;
    /**
     * @generated from protobuf field: mlmbox.types.Asset.Id target_asset = 2;
     */
    targetAsset?: Asset_Id;
}
// @generated message type with reflection information, may provide speed optimized methods
class AssetPair$Type extends MessageType<AssetPair> {
    constructor() {
        super("mlmbox.types.AssetPair", [
            { no: 1, name: "asset_pair_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "asset_pair_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "source_asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "target_asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<AssetPair>): AssetPair {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assetPairId = 0;
        message.assetPairName = "";
        message.sourceAssetId = 0;
        message.targetAssetId = 0;
        if (value !== undefined)
            reflectionMergePartial<AssetPair>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssetPair): AssetPair {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 asset_pair_id */ 1:
                    message.assetPairId = reader.uint32();
                    break;
                case /* string asset_pair_name */ 2:
                    message.assetPairName = reader.string();
                    break;
                case /* uint32 source_asset_id */ 3:
                    message.sourceAssetId = reader.uint32();
                    break;
                case /* uint32 target_asset_id */ 4:
                    message.targetAssetId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssetPair, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 asset_pair_id = 1; */
        if (message.assetPairId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.assetPairId);
        /* string asset_pair_name = 2; */
        if (message.assetPairName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.assetPairName);
        /* uint32 source_asset_id = 3; */
        if (message.sourceAssetId !== 0)
            writer.tag(3, WireType.Varint).uint32(message.sourceAssetId);
        /* uint32 target_asset_id = 4; */
        if (message.targetAssetId !== 0)
            writer.tag(4, WireType.Varint).uint32(message.targetAssetId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.AssetPair
 */
export const AssetPair = new AssetPair$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssetPair_Id$Type extends MessageType<AssetPair_Id> {
    constructor() {
        super("mlmbox.types.AssetPair.Id", [
            { no: 1, name: "asset_pair_id", kind: "scalar", oneof: "query", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "asset_pair_name", kind: "scalar", oneof: "query", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "assets", kind: "message", oneof: "query", T: () => AssetPair_Id_Assets }
        ]);
    }
    create(value?: PartialMessage<AssetPair_Id>): AssetPair_Id {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AssetPair_Id>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssetPair_Id): AssetPair_Id {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 asset_pair_id */ 1:
                    message.query = {
                        oneofKind: "assetPairId",
                        assetPairId: reader.uint32()
                    };
                    break;
                case /* string asset_pair_name */ 2:
                    message.query = {
                        oneofKind: "assetPairName",
                        assetPairName: reader.string()
                    };
                    break;
                case /* mlmbox.types.AssetPair.Id.Assets assets */ 3:
                    message.query = {
                        oneofKind: "assets",
                        assets: AssetPair_Id_Assets.internalBinaryRead(reader, reader.uint32(), options, (message.query as any).assets)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssetPair_Id, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 asset_pair_id = 1; */
        if (message.query.oneofKind === "assetPairId")
            writer.tag(1, WireType.Varint).uint32(message.query.assetPairId);
        /* string asset_pair_name = 2; */
        if (message.query.oneofKind === "assetPairName")
            writer.tag(2, WireType.LengthDelimited).string(message.query.assetPairName);
        /* mlmbox.types.AssetPair.Id.Assets assets = 3; */
        if (message.query.oneofKind === "assets")
            AssetPair_Id_Assets.internalBinaryWrite(message.query.assets, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.AssetPair.Id
 */
export const AssetPair_Id = new AssetPair_Id$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssetPair_Id_Assets$Type extends MessageType<AssetPair_Id_Assets> {
    constructor() {
        super("mlmbox.types.AssetPair.Id.Assets", [
            { no: 1, name: "source_asset", kind: "message", T: () => Asset_Id },
            { no: 2, name: "target_asset", kind: "message", T: () => Asset_Id }
        ]);
    }
    create(value?: PartialMessage<AssetPair_Id_Assets>): AssetPair_Id_Assets {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AssetPair_Id_Assets>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssetPair_Id_Assets): AssetPair_Id_Assets {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Asset.Id source_asset */ 1:
                    message.sourceAsset = Asset_Id.internalBinaryRead(reader, reader.uint32(), options, message.sourceAsset);
                    break;
                case /* mlmbox.types.Asset.Id target_asset */ 2:
                    message.targetAsset = Asset_Id.internalBinaryRead(reader, reader.uint32(), options, message.targetAsset);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssetPair_Id_Assets, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Asset.Id source_asset = 1; */
        if (message.sourceAsset)
            Asset_Id.internalBinaryWrite(message.sourceAsset, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Asset.Id target_asset = 2; */
        if (message.targetAsset)
            Asset_Id.internalBinaryWrite(message.targetAsset, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.AssetPair.Id.Assets
 */
export const AssetPair_Id_Assets = new AssetPair_Id_Assets$Type();
